module.exports = __webpack_public_path__ + "static/salon-view.fe516763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/salon-view.jpg
// module id = 470
// module chunks = 233015634327247